import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import Pager from '@/components/PagerComponent'

import Multiselect from 'vue-multiselect'

import { PermissionEnum } from '@/enums/permissions.enum'
import { Modal } from 'bootstrap';

export default {

  components: {
    Multiselect,
    Pager
  },

  setup () {
    return { v$: useVuelidate() }
  },

  data () {
    return {
      criterias: {
        selectedRoleName: '',
        selectedRoleDescription: '',
        selectedRolePermissions: [],
        selectedRoleInternal: false,
        selectedRoleLot: ''
      },
      responseErr: '',
      error: false,
      validationError: false,
      isProcessing: false,
      permissions: PermissionEnum
    }
  },

  created () {

  },

  methods: {
    createProfile () {
      this.validationError = this.v$.$invalid

      if (!this.validationError) {
        this.createNewProfile()
      }
    },

    async createNewProfile () {
      this.isProcessing = true
      this.responseErr = null
      let successMsg = null

      this.$store.dispatch('profiles/create', {
        roleName: this.criterias.selectedRoleName,
        roleDescription: this.criterias.selectedRoleDescription,
        rolePermissions: this.criterias.selectedRolePermissions,
        roleInternal: this.criterias.selectedRoleInternal,
        roleLot: this.criterias.selectedRoleLot
      }).then(
        () => {
          successMsg = this.$i18n.t('label.profile.profileCreatedSuccess', [this.criterias.selectedRoleName] )
          this.showSuccess(successMsg)
          this.isProcessing = true
          this.$router.push({ name: 'profile-list' })
        },
        error => {
          this.error = true
          this.isProcessing = false
          this.responseErr = error || 'BAD_REQUEST'
        }
      )
    },

    status (validation) {
      return {
        'validation-error': validation.$invalid && this.validationError
      }
    },

    showError (msg) {
      let errorModalElement = document.getElementById('errorModal')
      let errorModal = new Modal(errorModalElement)
      errorModal.show()
      document.getElementById('errorModalMsg').innerHTML = this.$i18n.t('error.' + msg)
    },

    showSuccess (msg) {
      let successModal = new Modal(document.getElementById('successModal'))
      successModal.show()
      document.getElementById('successModalMsg').innerHTML = msg
    },

    leavePage () {
      this.$router.push({ name: 'profile-list' })
    },

    reset () {
      this.criterias.selectedRoleName = ''
      this.criterias.selectedRoleDescription = ''
      this.criterias.selectedRolePermissions = []
      this.criterias.selectedRoleInternal = false
      this.criterias.selectedRoleLot = ''
      this.validationError = false
      this.error = false
    }
  },

  validations() {
    return {
      criterias: {
        selectedRoleName: { required },
        selectedRoleDescription: {},
        selectedRolePermissions: { required },
        selectedRoleInternal: {},
        selectedRoleLot: { required }
      }
    }
  }
}
